import React, { useCallback, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { view, i18next } from '@yola/ws-sdk';
import store from 'src/js/store';
import canBeMovedForward from '../helpers/can-be-moved-forward';
import useElementSiblingWatcher from '../hooks/use-element-sibling-watcher';
import Trigger from '../../../../common/components/trigger';
import trackReorderCompositeWidgetClicked from '../trackers/track-reorder-composite-widget-clicked';
import constants from '../constants/common';

const { Icon } = designSystem;

const MoveForward = forwardRef(({ elementId }, ref) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const disabled = useElementSiblingWatcher(
    liveElement,
    (element) => element.nextElementSibling !== null,
    (element) => !canBeMovedForward(element)
  );

  const moveForward = useCallback(() => {
    const { nextElementSibling } = liveElement;

    if (nextElementSibling) {
      const refElementId = view.accessors.getLiveElementId(nextElementSibling);
      store.dispatch(view.actions.shiftElement(elementId, refElementId));

      trackReorderCompositeWidgetClicked({
        triggerId: constants.MOVE_FORWARD,
        elementId,
      });
    }
  }, [elementId, liveElement]);

  return (
    <Trigger
      ref={ref}
      data-tip={i18next.t('Move forward')}
      disabled={disabled}
      onClick={moveForward}
    >
      <Icon glyph="layers-forward" />
    </Trigger>
  );
});

MoveForward.displayName = 'MoveForward';

MoveForward.propTypes = {
  elementId: PropTypes.string.isRequired,
};

export default MoveForward;
